import { useQuery} from '@tanstack/react-query';

import { useReferalApi } from '../../hooks/useRefferalApi';

type Params = {
  sortBy?: string;
  sortOrder?: string;
  page?: number;
  limit?: number;
  addedByFilter?: string;
  statusFilter?: string;
  search?: string;
};

export const useReferalManagement = (queryParams: Params) => {
  
  const { getAllRefferal } = useReferalApi();
  const {
    data,
    isLoading: isFetching,
    refetch,
    isRefetching,
  } = useQuery({
    queryKey: ['getReferal', queryParams],
    queryFn: () => {
      return getAllRefferal(queryParams);
    },
  });

  const isLoading = isFetching || isRefetching;

  return {
    data,
    isLoading,
    refetch,
  };
};



